export const production = {
  site: {
    baseName: 'conveyancer'
  },
  stripe: {
    key: 'pk_live_p6bzNHvI0tYjgVQoQHNsSIKd00chqZ33Qz'
  },
  api: {
    url: '/api/v1/user',
    baseUrl: 'https://app.searchlighttechnology.com.au'
  }
};

export default production;
